module.exports = __webpack_public_path__ + "static/media/flipfootGrid.1411c3ea.png";